// extracted by mini-css-extract-plugin
var _1 = "Card-moduletext__ZKxXO ClampingText-moduleclampingText__ANX4H";
export { _1 as "text" }
